import React from 'react'
import EmploymentChart from './EmploymentChart'

export default function Employment() {
  return (
    <>
      <EmploymentChart />
    </>
  )
}
